import React, { Component } from 'react';
import './Button.module.scss';


import generateClipPath from 'utilities/generateClipPath'

class Button extends Component {

    constructor(props) {
        super(props);

        this.handleClick        = this.handleClick.bind(this);
        
    }

    handleClick(e) {
        if(this.props.onClick) {
            this.props.onClick();
            e.preventDefault();
        }
    }

    render() {
        let {item} = this.props
        return (
            <a  
                onClick={this.handleClick}
                target={`${(item.link_type == 'link_external') ? '_blank' : '_self'}`} 
                download={item.link_type == 'file'} 
                href={item.link_type == 'file' ? `/storage/${item.link_file}` : item.link} 
                style={{
                    backgroundColor: `${item.button_color}`,
                    clipPath: this.props.noBorder ? null : generateClipPath(0,15,0,2, 500, 500), 
                    color: `${item.text_color}`}} 
                styleName='button'
            >
                {item.text}
            </a>
        );
    }
}

export default Button;